export const numberWithSpaces = (x: number | string) => {
  if (!x) return;
  return x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
};

export const secretCodeWithSpaces = (x: number | string) => {
  if (!x) return;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
